'use strict';

exports.__esModule = true;
exports.safelyParseJsonData = safelyParseJsonData;

var _clone = require('./clone');

function safelyParseJsonData(data) {
  var result = {
    tags: [],
    settings: {}
  };
  try {
    result = (0, _clone.clone)(JSON.parse(data));
  } catch (error) {}
  return result;
}